import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header.js';
import Footer from './components/Footer.js';
import BackgroundEffects from './components/BackgroundEffects.js';
import { MarketProvider } from './context/MarketContext';
import { ThemeProvider, useTheme } from './context/ThemeContext.js';
import HomePage from './pages/HomePage.js';
import AcademyPage from './pages/AcademyPage.js';
import AboutPage from './pages/AboutPage.js';
import ComingSoonPage from './pages/ComingSoonPage.js';
import ResourcesPage from './pages/ResourcesPage.js';
import ProbabilityPage from './pages/ProbabilityPage.js';
import BlogPage from './pages/BlogPage.js';

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const AppContent = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { isLight } = useTheme();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative min-h-screen">
      <BackgroundEffects isLight={isLight} />
      <Header isScrolled={isScrolled} />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/research" element={<ComingSoonPage title="Research" />} />
        <Route path="/tools" element={<ComingSoonPage title="Tools" />} />
        <Route path="/academy" element={<AcademyPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/resources/probability" element={<ProbabilityPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/blog" element={<BlogPage />} />
      </Routes>

      <Footer />
    </div>
  );
};

const App = () => {
  return (
    <ThemeProvider>
      <MarketProvider>
        <Router>
          <ScrollToTop />
          <AppContent />
        </Router>
      </MarketProvider>
    </ThemeProvider>
  );
};

export default App;
